/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Copy_FailedInputs */

const bn_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুলিপি ব্যর্থ হয়েছে`)
};

const de_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Kopieren ist fehlgeschlagen`)
};

const el_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η αντιγραφή απέτυχε`)
};

const en_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy failed`)
};

const es_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia fallida`)
};

const fr_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la copie`)
};

const hi_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि विफल`)
};

const hu_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A másolás nem sikerült`)
};

const id_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyalinan gagal`)
};

const it_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia non riuscita`)
};

const ja_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーに失敗しました`)
};

const ko_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복사 실패`)
};

const nl_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiëren mislukt`)
};

const pl_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiowanie nie powiodło się`)
};

const pt_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na cópia`)
};

const ru_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось скопировать`)
};

const sv_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieringen misslyckades`)
};

const tr_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyalama başarısız oldu`)
};

const uk_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка копіювання`)
};

const vi_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép không thành công`)
};

const zh_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制失败`)
};

const zh_hant_game_copy_failed = /** @type {(inputs: Game_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製失敗`)
};

/**
* | output |
* | --- |
* | "Copy failed" |
*
* @param {Game_Copy_FailedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_copy_failed = /** @type {((inputs?: Game_Copy_FailedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Copy_FailedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_copy_failed(inputs)
	if (locale === "de") return de_game_copy_failed(inputs)
	if (locale === "el") return el_game_copy_failed(inputs)
	if (locale === "en") return en_game_copy_failed(inputs)
	if (locale === "es") return es_game_copy_failed(inputs)
	if (locale === "fr") return fr_game_copy_failed(inputs)
	if (locale === "hi") return hi_game_copy_failed(inputs)
	if (locale === "hu") return hu_game_copy_failed(inputs)
	if (locale === "id") return id_game_copy_failed(inputs)
	if (locale === "it") return it_game_copy_failed(inputs)
	if (locale === "ja") return ja_game_copy_failed(inputs)
	if (locale === "ko") return ko_game_copy_failed(inputs)
	if (locale === "nl") return nl_game_copy_failed(inputs)
	if (locale === "pl") return pl_game_copy_failed(inputs)
	if (locale === "pt") return pt_game_copy_failed(inputs)
	if (locale === "ru") return ru_game_copy_failed(inputs)
	if (locale === "sv") return sv_game_copy_failed(inputs)
	if (locale === "tr") return tr_game_copy_failed(inputs)
	if (locale === "uk") return uk_game_copy_failed(inputs)
	if (locale === "vi") return vi_game_copy_failed(inputs)
	if (locale === "zh") return zh_game_copy_failed(inputs)
	return zh_hant_game_copy_failed(inputs)
});